import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  TemplatingConfig,
  TemplatingConfigObject,
  TemplatingConfigObjectRelation,
  TemplatingConfigObjectRoot, TemplatingConfigTypes
} from '../../../shared/interface/templating-config';
import {TemplateService} from '../../../shared/services/template.service';
import {config, ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';

export interface ConfigMap {
  prefix?: string;
  config: TemplatingConfigObject;
}

@Component({
  selector: 'app-templating-config-map',
  templateUrl: './templating-config-map.component.html',
  styleUrls: ['./templating-config-map.component.scss']
})
export class TemplatingConfigMapComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  templatingConfig?: TemplatingConfig;
  currentObjectConfig?: TemplatingConfigObjectRoot;
  currentObjectConfigControl: FormControl;
  configMaps = {};

  constructor(
    private templateService: TemplateService,
    private fb: FormBuilder,
  ) {
    this.templateService.getTemplatingConfig()
      .subscribe((templatingConfig: TemplatingConfig) => {
        this.templatingConfig = templatingConfig;
        templatingConfig.config.types.forEach((type: TemplatingConfigTypes) => {
          this.getObjectConfigs(type.fieldsConfig);
        });
      });

    this.currentObjectConfigControl = fb.control('');
  }

  ngOnInit(): void {
    this.currentObjectConfigControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((current: TemplatingConfigObjectRoot) => this.currentObjectConfig = current);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getObjectConfigs(fieldsConfig: string): ConfigMap[] {
    if (this.configMaps.hasOwnProperty(fieldsConfig)) {
      return this.configMaps[fieldsConfig];
    }

    const configs: ConfigMap[] = [];

    this.templatingConfig.config.objects.forEach((objectConfigRoot: TemplatingConfigObjectRoot) => {
      if (objectConfigRoot.name === fieldsConfig) {
        configs.push({
          prefix: null,
          config: objectConfigRoot.properties
        });

        objectConfigRoot.properties.relations.forEach((relation: TemplatingConfigObjectRelation) => {
          const relationObjectConfig = this.getObjectConfig(relation.object);
          configs.push({
            prefix: relation.prefix,
            config: relationObjectConfig
          });

          relationObjectConfig.relations.forEach((childRelation: TemplatingConfigObjectRelation) => {
            if (!childRelation.depth || childRelation.depth > 1) {
              const childRelationObjectConfig = this.getObjectConfig(childRelation.object);
              configs.push({
                prefix: relation.prefix + '.' + childRelation.prefix,
                config: childRelationObjectConfig
              });
            }
          });
        });
      }
    });

    this.configMaps[fieldsConfig] = configs;

    return configs;
  }

  private getObjectConfig(name: string): TemplatingConfigObject {
    let result = null;
    this.templatingConfig.config.objects.forEach((objectConfigRoot: TemplatingConfigObjectRoot) => {
      if (objectConfigRoot.name === name) {
        result = objectConfigRoot.properties;
      }
    });

    return result;
  }
}
